<script lang="ts" setup>
import DebouncedField from '@/components/DebouncedField/index.vue'
import { useSidebarStore } from '~~/src/stores/sidebar'
import { useElementalListsStore } from '~~/src/stores/useElementalListsStore'

interface IProps {
  focused?: boolean
}

interface Emits {
  (event: 'blur'): void
}

const props = defineProps<IProps>()
const emits = defineEmits<Emits>()

const { focused } = toRefs(props)

defineOptions({ name: 'SearchHeader' })

const { setSearchQuery, state: elemetalListState } = useElementalListsStore()
const { state } = useSidebarStore()

const value = ref(elemetalListState.query)
watch(value, (val) => {
  setSearchQuery(val ?? '')
})

const fieldRef = ref<InstanceType<typeof DebouncedField> | null>(null)

const focusField = () => {
  fieldRef.value?.focus()
}

defineExpose({ focusField })

onMounted(() => {
  if (focused.value)
    fieldRef.value?.focus()
})

const handlerBlur = () => {
  emits('blur')
}

const clearSearch = () => {
  value.value = ''
  fieldRef.value?.reset()
}
</script>

<template>
  <DebouncedField
    ref="fieldRef"
    v-model="value"
    placeholder="Search your library"
    wrapper-class="bg-grayLighter text-darkGray p-2 ml-2 rounded-full focus-within:ring-1 focus-within:ring-darkGray overflow-hidden"
    @blur="handlerBlur"
  >
    <template #right-addon>
      <div class="flex items-center gap-1">
        <button
          v-if="value"
          class="text-darkGray hover:text-black"
          aria-label="Clear search"
          @click="clearSearch"
        >
          <div class="i-material-symbols:close-rounded text-lg" />
        </button>
        <div v-else class="flex items-center gap-.5 text-xs border-1 text-darkGray border-softGray p-1 rounded-1">
          <IconCommand h-3 w-3 />
          <span role="img">F</span>
        </div>
      </div>
    </template>
  </DebouncedField>
</template>
